import {useGetShopByPublicLink, useGetShops, useGetShopVerified} from "../../../services/ContentManager";
import CouponRedeemSection from "../../../components/VendorComponents/CouponRedeemSection";
import React, {useState} from "react";
import {Box, Card, CardContent, Grid, Typography} from "@mui/material";
import {EmojiEvents, NoteOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import { Redirect } from "react-router-dom";
import {useParams} from "react-router-dom";
import CircularLoading from "../../../components/CircularLoading";

/**
 * Mostra la schermata di riscatto del codice
 * @param uid se settato mostra la lista di possibili shop che possono fare la redeem
 * @param auto prende gli id dall' url ignorando uid
 * @returns {JSX.Element}
 * @constructor
 */
export default function CouponRedeem({uid, auto = false}) {
    let params = useParams();//prendo i dati dall'url
    let publicLink

    if (auto) {
        publicLink = params.publicLink;
    }

    let {shops, status: statusShops} = useGetShops(uid, !auto);// carica gli shop dall' uid se non è auto
    let {shop, status: statusShop} = useGetShopByPublicLink(publicLink, auto);//se in auto carica il singolo shop dato nell' url verificando che appartenga al vendor
    const [isCouponOpen, setIsCouponOpen] = useState(false);//nascondere tutto se si apre la schermata dei coupon
    const {t} = useTranslation();

    if (statusShops === 'loading' || statusShop === 'loading') return <CircularLoading/>;

    if (auto && !shop.id) {//se lo shop non è stato trovato allora è un url errato
        return <Redirect exact to="/unutorized"/>;
    }

    return (
        <Grid container direction={'column'}>
            <Grid item>
                <CouponRedeemSection
                    shop={auto && shop}
                    shops={shops}
                    onCouponDetailsOpen={setIsCouponOpen}
                />
            </Grid>
            {
                !isCouponOpen &&
                <Grid item>
                    <Typography variant="h6" fontWeight={700} textAlign="center" mb={2}>
                        {t('whatAwardsAndVoucherAre')}
                    </Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <ExplainCard icon={<EmojiEvents/>} title={t('awardsCommunity')}
                                         text={t('awardsInCatalogDescription')}/>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <ExplainCard icon={<NoteOutlined/>} title={t('voucher')}
                                         text={t('voucherCardDescription')}/>
                        </Grid>
                    </Grid>
                </Grid>
            }
        </Grid>
    );
}

// Stesse icone della barra laterale, così l'esercente riconosce subito le due voci
function ExplainCard({icon, title, text}) {
    return (
        <Card sx={{height: '100%'}}>
            <CardContent>
                <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
                    <Box sx={{
                        width: 44, height: 44, borderRadius: '50%', flexShrink: 0,
                        bgcolor: 'primary.main', color: 'common.white',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>{icon}</Box>
                    <Typography variant="h6" fontWeight={700}>{title}</Typography>
                </Box>
                <Typography variant="body2" color="textSecondary">{text}</Typography>
            </CardContent>
        </Card>
    );
}
